import '@/assets/css/tailwind.css'
import '@/assets/css/modals.scss'
import '@/assets/css/hamburgers/hamburgers.scss'
import '@/assets/css/line-awesome.min.css'
import '@/assets/css/colors.scss'
import '@/assets/css/easing.scss'
import '@/assets/css/main.scss'
import '@/assets/css/theme/index.css'

var _ = require('lodash')
var Fuse = require('fuse.js')
window._ = _
window.Fuse = Fuse

import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App.vue'
import router from './router'
import store from '@/store/index.js'
import './registerServiceWorker'
import VueOfflinePlugin from '@/common/offline.js'
import VModal from 'vue-js-modal'
import ApiService from "@/common/api.service.js"
import LocalService from "@/common/local.service.js"
import AppConstants from '@/common/constants.js'
import VueCurrencyFilter from 'vue-currency-filter'
import Toasted from 'vue-toasted';
import VueSocketIO from 'vue-socket.io'
import '@/common/filters.js'
import { defineCustomElements as defineIonPhaser } from '@ion-phaser/core/loader'

Vue.config.ignoredElements = [/ion-\w*/];

Vue.use(LocalService)
Vue.use(AppConstants)
Vue.use(ElementUI)
Vue.use(VueOfflinePlugin)
Vue.use(VModal, { dialog: true })
Vue.use(VueCurrencyFilter, {
    symbol : 'RON',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'end',
    symbolSpacing: true
    // {{ textInput | currency(configSymbol, configSeparator, configFractionCount, configFractionSeparator, configSymbolPosition, configSymbolSpacing)}}
})

Vue.use(Toasted, {
    position: 'top-right',
    fullWidth: true,
    fitToScreen: true,
    duration: 3000,
    action : {
        text : 'Dismiss',
        onClick : (e, toastObject) => {
            toastObject.goAway(0);
        }
    },
})

Vue.config.productionTip = false

ApiService.init();

defineIonPhaser(window);

window.vm = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
